<template>
  <div class="scroll-wrapper">
    <div class="container-fluid">
      <h3 class="pt-2 pb-2">Филиалы</h3>
      <div class="row">
        <div class="branch-content p-5 pt-0">
          <el-card class="col-10 offset-1">
          <div class="row">
            <div class="col-8">
              <el-tree ref="tree" :data="treeData" node-key="id" @node-expand="handleNodeExpand"
                       @node-collapse="handleNodeCollapse">
                <template #default="{ data }">
                  <div class="fragment" style="display: flex; align-items: center;">
                    <font-awesome-icon v-if="data.type === 'city'" icon="city" style="margin-right: 5px;" />
                    <font-awesome-icon v-else-if="data.type === 'branch'" icon="building" style="margin-right: 5px;" />
                    <font-awesome-icon v-else-if="data.type === 'room'" icon="chair" style="margin-right: 5px;" />
                    <div class="title">{{ data.name }}</div>
                    <div class="time-working" v-if="data.type === 'branch' || data.type === 'room'">
                      ({{ getWorkingHours(data) }})
                    </div>
                    <div v-if="data.type === 'branch'" style="display: flex; align-items: center;">
                      <el-button style="margin-left: 10px;font-size: 12px; color: #4a90e2" text :icon="Plus"
                                 @click.stop="showAddRoomDialog(data)">кабинет
                      </el-button>
                      <el-button style="font-size: 12px; color: #4a90e2" text @click.stop="editBranch(data)"
                                 size="small">
                        <font-awesome-icon icon="pen-to-square" style="font-size: 12px; color: #4a90e2" />
                      </el-button>
                      <el-button style="margin-left: 0;" text @click.stop="deleteBranch(data)" size="small">
                        <font-awesome-icon icon="trash-can" style="font-size: 12px; color: red" />
                      </el-button>
                    </div>
                    <div v-if="data.type === 'city' && (expandedNodes.includes(data.id) || data.children.length === 0)"
                         style="margin-left: 20px; display: flex; align-items: center;">
                      <el-button style="font-size: 12px; color: #4a90e2" text :icon="Plus"
                                 @click.stop="showAddBranchDialog(data)">филиал
                      </el-button>
                      <el-button text @click.stop="editCity(data)" size="small">
                        <font-awesome-icon icon="pen-to-square" style="font-size: 12px; color: #4a90e2" />
                      </el-button>
                      <el-button text @click.stop="deleteCity(data)" size="small" style="margin-left: 0;">
                        <font-awesome-icon icon="trash-can" style="font-size: 12px; color: red" />
                      </el-button>
                    </div>
                    <div v-if="data.type === 'room'" style="margin-left: 20px; display: flex; align-items: center;">
                      <el-button text @click.stop="editRoom(data)" size="small">
                        <font-awesome-icon icon="pen-to-square" style="font-size: 12px; color: #4a90e2" />
                      </el-button>
                      <el-button text @click.stop="deleteRoom(data)" size="small" style="margin-left: 0;">
                        <font-awesome-icon icon="trash-can" style="font-size: 12px; color: red" />
                      </el-button>
                    </div>
                  </div>
                </template>
              </el-tree>
            </div>
            <div class="col-4">
              <el-button type="primary" @click="addCity">Добавить город</el-button>
            </div>
          </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
  <AddCity ref="addCity" />
  <ModalBranch ref="modalBranch" @update-city="updateCity" />
  <ModalRoom ref="modalRoom" @update-branch="updateBranch" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBuilding, faChair, faCity, faPenToSquare, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Plus } from '@element-plus/icons-vue'
import store from '@/components/store/store'
import ModalBranch from '@/components/views/modal/ModalBranch.vue'
import ModalRoom from '@/components/views/modal/ModalRoom.vue'
import AddCity from '@/components/views/modal/ModalCity.vue'
import { mapState } from 'vuex'

library.add(faCity, faBuilding, faChair, faPenToSquare, faTrashCan)

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Branches',
  computed: {
    Plus() {
      return Plus
    },
    ...mapState('cities', ['cities']),
    treeData() {
      return this.cities
    }
  },
  components: { AddCity, ModalBranch, ModalRoom, FontAwesomeIcon },
  data() {
    return {
      expandedNodes: [],
      showAddCityDialog: false,
      newCity: { name: '', id: null, type: 'city', children: [] },
      showAddBranchDialogVisible: false,
      selectedNode: null,
      showAddRoomDialogVisible: false,
      editNodeDialogVisible: false,
      editingNode: {},
      editRoomDialogVisible: false,
      editingOffice: {},
      defaultWorking: {
        start: '8:00',
        end: '21:00'
      }
    }
  },
  async created() {
    await this.$store.dispatch('cities/getCities');
  },
  methods: {
    updateBranch(city_id, branch_id) {
      this.$nextTick(() => {
        for (let i in this.$refs.tree.store.root.childNodes) {
          if (this.$refs.tree.store.root.childNodes[i].data.id === city_id) {
            this.$refs.tree.store.root.childNodes[i].expanded = true
            break
          }
        }
        for (let i in this.$refs.tree.store.nodesMap) {
          if (this.$refs.tree.store.nodesMap[i].data.id === branch_id) {
            this.$refs.tree.store.nodesMap[i].expanded = true
            break
          }
        }
      })
    },
    updateCity(id) {
      this.$nextTick(() => {
        for (let i in this.$refs.tree.store.root.childNodes) {
          if (this.$refs.tree.store.root.childNodes[i].data.id === id) {
            this.$refs.tree.store.root.childNodes[i].expanded = true
            break
          }
        }
      })
    },
    addCity() {
      this.$refs.addCity.open()
    },
    showAddBranchDialog(node) {
      this.selectedNode = node
      this.$refs.modalBranch.open({
        id: null,
        city_id: node.id,
        name: '',
        working: {
          start: null,
          end: null
        }
      }, node.name)
    },
    showAddRoomDialog(node) {
      this.selectedNode = node
      const city_name = this.findCityName(node.city_id)
      this.$refs.modalRoom.open({
        id: null,
        city_id: node.city_id,
        branch_id: node.id,
        working: {
          start: node.working.start,
          end: node.working.end
        }
      }, city_name, node.name)
    },
    editRoom(node) {
      this.editingNode = node
      const city_name = this.findCityName(node.city_id)
      let branch_name = ''
      const searchCity = this.treeData.find(city => city.id === node.city_id)
      if (searchCity) {
        const searchBranch = searchCity.children.find(city => city.id === node.branch_id)
        if (searchBranch) {
          branch_name = searchBranch.name
        }
      }
      this.$refs.modalRoom.open(node, city_name, branch_name)
    },
    handleNodeExpand(data) {
      this.expandedNodes.push(data.id)
    },
    handleNodeCollapse(data) {
      this.expandedNodes = this.expandedNodes.filter(id => id !== data.id)
    },
    deleteBranch(branch) {
      this.$confirm(`Вы уверены, что хотите удалить кабинет "${branch.name}"? <br> <small style="color: #ff7b00">Если есть вложение кабинетов, они так же будут удалены!</small>`, 'Внимание', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(async () => {
        await store.dispatch('cities/removeBranch', { id: branch.id })
        this.updateBranch(branch.city_id)
        this.$message({
          type: 'success',
          message: 'Кабинет удален'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Удаление отменено'
        })
      })
    },
    editBranch(room) {
      const name = this.findCityName(room.id)
      this.$refs.modalBranch.open(room, name)
    },
    deleteRoom(node) {
      const message = `Вы уверены, что хотите удалить кабинет "${node.name}"?`
      this.$confirm(message, 'Внимание', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning'
      }).then(async () => {
        await store.dispatch('cities/removeRoom', { id: node.id })
        this.updateBranch(node.city_id, node.branch_id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Удаление отменено'
        })
      })
    },
    editCity(node) {
      this.editingNode = node
      this.$refs.addCity.edit(node)
    },
    deleteCity(node) {
      let message = `Вы уверены, что хотите удалить город "${node.name}"? <br> <small style="color: #ff7b00">Это также удалит все филиалы и кабинеты, связанные с ним.</small>`
      this.$confirm(message, 'Внимание', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(async () => {
        await store.dispatch('cities/deleteCity', { id: node.id })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Удаление отменено'
        })
      })
    },
    findCityName(branchId) {
      let cityName = ''
      for (let i in this.treeData) {
        const search = this.treeData[i].children.find(item => item.id === branchId)
        if (search) {
          cityName = this.treeData[i].name
          break
        }
      }
      return cityName
    },
    getWorkingHours(data) {
      return data.working.start + ' - ' + data.working.end
    }
  }
}
</script>
<style>
.el-tree-node__content {
  height: 40px;
}

.el-tree-node:focus > .el-tree-node__content,
.el-tree-node__content:hover {
  background-color: initial;
}
</style>
<style scoped>
.title {
  font-size: large;
}

.time-working {
  margin-left: 12px;
  color: silver;
}

.scroll-wrapper {
  height: 100%;
  overflow-y: auto;
}
</style>
